import {registerRequestInterceptor, registerResponseInterceptor} from "@/Fwk/Http/comRequest";
import {AuthInterceptor} from "@/Fwk/Http/Interceptors/AuthInterceptor";
import {LogRequestInterceptor} from "@/Fwk/Http/Interceptors/LogRequestInterceptor";
import {LogResDataInterceptor} from "@/Fwk/Http/Interceptors/LogResDataInterceptor";

export enum NetType {
    CheckRegister,
    Register,
    Login,
    Logout,
    RefreshToken,
    ResetPwd,
    GetUserInfo,
    UpdateUser,

    visitorLogin,

    SendCode,
    CheckCode,

    VipConfigs,
    GameLevels,
    RedeemApply,
    RedeemCancel,
    RedeemCheck,
    // RedeemEdit,
    RedeemOrderList,
    RedeemConfig,

    // 商店充值相关接口
    PaymentItemsList,
    GetXtgConfig,
    GetXtgLink,
    GetUserLatestOrders,
    QueryOrder,
}


export default class RequestMgr {
    private static _urls: Map<NetType, string> = new Map();

    public static Init() {
        // 注册请求拦截器
        registerRequestInterceptor(AuthInterceptor);
        registerRequestInterceptor(LogRequestInterceptor);

        // 注册响应拦截器
        registerResponseInterceptor(LogResDataInterceptor);

        //客户端-用户认证管理接口
        this._urls.set(NetType.CheckRegister, "/hs-apis/acct/v1.0/user/check_register");
        this._urls.set(NetType.Login, "/hs-apis/acct/v1.0/user/login");
        this._urls.set(NetType.Logout, "/hs-apis/acct/v1.0/user/logout");
        this._urls.set(NetType.RefreshToken, "/hs-apis/acct/v1.0/user/refresh_token");
        this._urls.set(NetType.Register, "/hs-apis/acct/v1.0/user/register");
        this._urls.set(NetType.ResetPwd, "/hs-apis/acct/v1.0/user/reset_pw");
        this._urls.set(NetType.GetUserInfo, "/hs-apis/acct/v1.0/user/user_base_info");
        this._urls.set(NetType.visitorLogin, "/hs-apis/acct/v1.0/user/visitor_login");
        this._urls.set(NetType.UpdateUser, "/hs-apis/acct/v1.0/user/update");

        //客户端-短信管理接口
        this._urls.set(NetType.SendCode, "/hs-apis/acct/v1.0/user_sms/send_code");
        this._urls.set(NetType.CheckCode, "/hs-apis/acct/v1.0/user_sms/check_code");

        // 客户端-vip配置管理接口
        this._urls.set(NetType.VipConfigs, "/hs-apis/acct/v1.0/vip/vip_configs");

        //客户端-游戏等级配置管理接口
        this._urls.set(NetType.GameLevels, "/hs-apis/acct/v1.0/game_levels/list_game_levels");

        //ALL-现金兑换接口
        this._urls.set(NetType.RedeemApply, "/hs-apis/payout/v1.0/withdraw/apply");//申请提现
        this._urls.set(NetType.RedeemCancel, "/hs-apis/payout/v1.0/withdraw/cancel");//取消提现
        this._urls.set(NetType.RedeemCheck, "/hs-apis/payout/v1.0/withdraw/check");//提现校验
        // this._urls.set(NetType.RedeemEdit, "/hs-apis/payout/v1.0/withdraw/edit");
        this._urls.set(NetType.RedeemOrderList, "/hs-apis/payout/v1.0/withdraw/order_list");//提现订单列表
        this._urls.set(NetType.RedeemConfig, "/hs-apis/payout/v1.0/withdraw/xtg_config");//打款方式配置

        // 商店充值相关接口
        this._urls.set(NetType.PaymentItemsList, "/hs-apis/acct/v1.0/pay_items/list");
        this._urls.set(NetType.GetXtgConfig, "/hs-apis/pay/v1.0/xtg_config/get_config");
        this._urls.set(NetType.GetXtgLink, "/hs-apis/pay/v1.0/xtg_config/get_link");
        this._urls.set(NetType.GetUserLatestOrders, "/hs-apis/pay/v1.0/user_order/latest_order");
        this._urls.set(NetType.QueryOrder, "/hs-apis/pay/v1.0/user_order/query_order");
    }

    public static getUrl(type: NetType):string {
        return this._urls.get(type) || '';
    }

}